"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CancellationSchema = void 0;
const azavista_types_1 = require("@azavista/azavista-types");
exports.CancellationSchema = {
    type: 'object',
    required: [],
    additionalProperties: false,
    properties: {
        disable_forms: {
            type: ['boolean'],
        },
        form_ids: {
            type: 'array',
            items: {
                type: 'string',
            },
        },
        email_campaign_id: {
            type: [
                'string',
                'null',
            ],
        },
        thank_you_page_id: {
            type: [
                'string',
                'null',
            ],
        },
        count_as: {
            type: [
                'string',
                'null',
            ],
            enum: ['', azavista_types_1.CrmStatus.CANCELLED, azavista_types_1.CrmStatus.DECLINED],
        },
        cancelled_stage_name: {
            type: 'string',
        },
        cancelled_with_reason_stage_name: {
            type: 'string',
        },
        register_workflow_id: {
            type: [
                'string',
                'null',
            ],
        },
        next_workflow_ids: {
            type: 'object',
            properties: {},
        },
    },
};
